import { motion } from "framer-motion";
import { usePrefersReducedMotion } from "@/hooks/useSmoothScroll";

// Calm, premium reveal-on-scroll wrapper (framer-motion whileInView).
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true, ...rest }) => {
  const reduced = usePrefersReducedMotion();
  if (reduced) {
    return (
      <div className={className} {...rest}>
        {children}
      </div>
    );
  }
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const SectionHeading = ({ kicker, title, subtitle, align = "left", testId }) => (
  <Reveal className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={testId}>
    {kicker && (
      <p className="text-[11px] font-mono-cs uppercase tracking-[0.22em] text-[#00d4ff] mb-4">{kicker}</p>
    )}
    <h2 className="font-display text-3xl sm:text-4xl lg:text-[2.75rem] font-semibold tracking-[-0.02em] leading-[1.08] text-foreground">
      {title}
    </h2>
    {subtitle && <p className="mt-4 text-base sm:text-lg text-muted-foreground leading-relaxed">{subtitle}</p>}
  </Reveal>
);
